const firebase = require('firebase');
require('firebase/storage');

const firebaseConfig = {
  apiKey: "AIzaSyB6MmX9-y2Qrw3Y7x_ADWAgOkbBNHTA1ac",
  authDomain: "newsarchive.firebaseapp.com",
  databaseURL: "https://newsarchive.firebaseio.com",
  projectId: "newsarchive",
  storageBucket: "newsarchive.appspot.com",
  messagingSenderId: "595990768689",
  appId: "1:595990768689:web:150fa4c437006d8969b910",
  measurementId: "G-KXDVTXCSN4"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

module.exports.db = firebaseApp.firestore();
module.exports.storage = firebaseApp.storage();


// WEBPACK FOOTER //
// ./src/firebase/init.js